import angular from 'angular';
import { default as orgDataService } from 'app/services/data/org.data.service';
import { default as userService } from 'app/services/membership/ss.user.service';
import dialogService from './customer-service-acceptance-dialog.service';

const library = require('@safe-systems/ss-ui-components');

const {
  loaderService,
  ssDialogService,
} = library;

export default angular.module('app.components.global.customerServiceAcceptanceDialog', [
  ssDialogService,
  orgDataService,
  userService,
  loaderService
])
  .service('customerServiceAcceptanceDialog', dialogService)
  .name;

console.log('app.components.global.customerServiceAcceptanceDialog created');
